// #region SEARCH
export const REMOVE_COMPARISON_PLAN = 'REMOVE_COMPARISON_PLAN';
export const ADD_COMPARISON_PLAN = 'ADD_COMPARISON_PLAN';
export const CLEAN_COMPARISON_PLANS = 'CLEAN_COMPARISON_PLANS';

export const FILTER_PLANS = 'FILTER_PLANS';

export const SET_SORT_OPTIONS = 'SET_SORT_OPTIONS';
export const SET_SORT_OPTION = 'SET_SORT_OPTION';
export const SET_PROVIDER_OPTION = 'SET_PROVIDER_OPTION';
export const FILTER_PLANS_MOBILE = 'FILTER_PLANS_MOBILE';

export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';

export const UNSELECT_FILTER_CATEGORY_OPTIONS = 'UNSELECT_FILTER_CATEGORY_OPTIONS';
export const APPLY_FILTER_CATEGORIES = 'APPLY_ALL_FILTER_CATEGORIES';
export const CLEAR_FILTER_CATEGORIES = 'CLEAR_ALL_FILTER_CATEGORIES';

// #endregion

// #region COMPARISON
export const OPEN_COMPARISON_ACCORDION = 'OPEN_COMPARISON_ACCORDION';
export const FETCH_COMPARISON_PRODUCTS_COVERAGE = 'FETCH_COMPARISON_PRODUCTS_COVERAGE';
// email
export const SENDING_EMAIL = 'SENDING_EMAIL';
export const SEND_EMAIL_DONE = 'SEND_EMAIL_DONE';
export const SEND_EMAIL_FAIL = 'SEND_EMAIL_FAIL';
export const CHANGE_EMAIL_MODAL_ATTR = 'CHANGE_EMAIL_MODAL_ATTR';
export const CHANGE_EMAIL_COLLAPSE_ATTR = 'CHANGE_EMAIL_COLLAPSE_ATTR';
// #endregion

// #region COVERAGE
export const GET_PRODUCT_INFO = 'GET_PRODUCT_INFO';
export const FETCH_PRODUCT_COVERAGE = 'FETCH_PRODUCT_COVERAGE';
export const OPEN_COVERAGE_ACCORDION = 'OPEN_COVERAGE_ACCORDION';
// #endregion

// #region PURCHASE
// coupon
export const FETCH_DISCOUNT_COUPON = 'FETCH_DISCOUNT_COUPON';
export const SET_COUPON_TEXT = 'SET_COUPON_TEXT';
export const CLEAR_COUPON = 'CLEAR_COUPON';

// Credit Coupon
export const FETCH_FIRST_ACTIVE_CREDIT_COUPON_SUCCESS = 'FETCH_FIRST_ACTIVE_CREDIT_COUPON_SUCCESS';
export const FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR = 'FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR';
export const SET_CREDIT_COUPON_CODE_TEXT = 'SET_CREDIT_COUPON_CODE_TEXT';
export const APPLY_CREDIT_COUPON_SUCCESS = 'APPLY_CREDIT_COUPON_SUCCESS';
export const APPLY_CREDIT_COUPON_ERROR = 'APPLY_CREDIT_COUPON_ERROR';
export const REMOVE_APPLIED_CREDIT_COUPON = 'REMOVE_APPLIED_CREDIT_COUPON';

// payment info
export const FETCH_PAYMENT_INFO = 'FETCH_PAYMENT_INFO';

// insured register
export const ADD_INSURED_FORM = 'ADD_INSURED_FORM';
export const REMOVE_INSURED_FORM = 'REMOVE_INSURED_FORM';
export const CHANGE_INSURED_FORM_ATTR = 'CHANGE_INSURED_FORM_ATTR';

// payment methods
export const FETCH_PAYMENT_METHODS = 'FETCH_PAYMENT_METHODS';
export const SELECT_PAYMENT_METHOD = 'SELECT_PAYMENT_METHOD';

// credit card
export const SELECT_CREDITCARD_BRAND = 'SELECT_CREDITCARD_BRAND';
export const SELECT_CREDITCARD_PARCEL = 'SELECT_CREDITCARD_PARCEL';
export const CHANGE_CREDITCARD_ATTR = 'CHANGE_CREDITCARD_ATTR';

// boleto
export const CHANGE_BOLETO_ATTR = 'CHANGE_BOLETO_ATTR';

// cash transfer
export const SELECT_BANK = 'SELECT_BANK';
export const CHANGE_SAFETYPAY_ATTR = 'CHANGE_SAFETYPAY_ATTR';

// cash
export const CHANGE_CASH_ATTR = 'CHANGE_CASH_ATTR';

// pix
export const CHANGE_PIX_ATTR = 'CHANGE_PIX_ATTR'

// contact form
export const CHANGE_CONTACT_ATTR = 'CHANGE_CONTACT_ATTR';

// accept terms
export const TOGGLE_ACCEPT_TERMS = 'TOGGLE_ACCEPT_TERMS';

// benefits
export const FETCH_BENEFITS_METHODS = 'FETCH_BENEFITS_METHODS';
export const FINISH_PURCHASE = 'FINISH_PURCHASE'

// clean cookies
export const CLEAN_COOKIES = 'CLEAN_COOKIES';

export const SET_PURCHASE_UUID = 'SET_PURCHASE_UUID';
export const VALIDATE_PURCHASE = 'VALIDATE_PURCHASE';
export const FETCH_ADDRESS = 'FETCH_ADDRESS';
export const CLEAR_ALERTS = 'CLEAR_ALERTS';

export const START_PURCHASE_LOADING = 'START_PURCHASE_LOADING';
export const END_PURCHASE_LOADING = 'END_PURCHASE_LOADING';

export const FETCH_PURCHASE_DATA = 'FETCH_PURCHASE_DATA';
// #endregion

// #region PURCHASE_STATUS
export const FETCH_PURCHASE_STATUS = 'FETCH_PURCHASE_STATUS'
// #endregion

// #region GENERAL
export const FETCH_PLANS = 'FETCH_PLANS';
export const SET_PARTNER = 'SET_PARTNER';
export const FETCH_PLANS_SEARCH = 'FETCH_PLANS_SEARCH';
export const FETCH_PLANS_PURCHASE = 'FETCH_PLANS_PURCHASE';
export const SET_QUOTATION_PARAMS = 'SET_QUOTATION_PARAMS';
export const FETCH_PLANS_COVERAGE = 'FETCH_PLANS_COVERAGE';
export const FETCH_PLANS_COMPARISON = 'FETCH_PLANS_COMPARISON';
export const UPDATE_PURCHASE_SUMMARY = 'UPDATE_PURCHASE_SUMMARY';
// #endregion

// #region MODALS
// purchase
export const OPEN_MODAL_EMAIL = 'OPEN_MODAL_EMAIL'
export const CLOSE_MODAL_EMAIL = 'CLOSE_MODAL_EMAIL'

export const OPEN_DETAIL_MODAL = 'OPEN_DETAIL_MODAL';
export const CLOSE_DETAIL_MODAL = 'CLOSE_DETAIL_MODAL';

export const OPEN_MODAL_FRANCHISE = 'OPEN_MODAL_FRANCHISE';
export const CLOSE_MODAL_FRANCHISE = 'CLOSE_MODAL_FRANCHISE';

export const OPEN_MODAL_OPERATOR_CONFIRMATION = 'OPEN_MODAL_OPERATOR_CONFIRMATION';
export const CLOSE_MODAL_OPERATOR_CONFIRMATION = 'CLOSE_MODAL_OPERATOR_CONFIRMATION';

export const OPEN_MODAL_FILTER_CATEGORY = 'OPEN_MODAL_FILTER_CATEGORY';
export const CLOSE_MODAL_FILTER_CATEGORY = 'CLOSE_MODAL_FILTER_CATEGORY';

export const OPEN_MODAL_STUDENT = 'OPEN_MODAL_STUDENT';
export const CLOSE_MODAL_STUDENT = 'CLOSE_MODAL_STUDENT';

export const OPEN_MODAL_SAFETYPAY = 'OPEN_MODAL_SAFETYPAY'
export const CLOSE_MODAL_SAFETYPAY = 'CLOSE_MODAL_SAFETYPAY'

export const OPEN_MODAL_TERMS_OF_USE = 'OPEN_MODAL_TERMS_OF_USE'
export const CLOSE_MODAL_TERMS_OF_USE = 'CLOSE_MODAL_TERMS_OF_USE'

export const OPEN_MODAL_PURCHASE_ERROR = 'OPEN_MODAL_PURCHASE_ERROR'
export const CLOSE_MODAL_PURCHASE_ERROR = 'CLOSE_MODAL_PURCHASE_ERROR'

export const OPEN_MODAL_COUPON_ERROR = 'OPEN_MODAL_COUPON_ERROR'
export const CLOSE_MODAL_COUPON_ERROR = 'CLOSE_MODAL_COUPON_ERROR'

export const OPEN_MODAL_PURCHASE_DATE_ERROR = 'OPEN_MODAL_PURCHASE_DATE_ERROR'
export const CLOSE_MODAL_PURCHASE_DATE_ERROR = 'CLOSE_MODAL_PURCHASE_DATE_ERROR'

export const OPEN_MODAL_GENERIC_ERROR = 'OPEN_MODAL_GENERIC_ERROR'
export const CLOSE_MODAL_GENERIC_ERROR = 'CLOSE_MODAL_GENERIC_ERROR'

export const OPEN_MODAL_TRAVEL_RENEWAL = 'OPEN_MODAL_TRAVEL_RENEWAL'
export const CLOSE_MODAL_TRAVEL_RENEWAL = 'CLOSE_MODAL_TRAVEL_RENEWAL'

export const OPEN_MODAL_RENEWAL_FRANCHISE = 'OPEN_MODAL_RENEWAL_FRANCHISE'
export const CLOSE_MODAL_RENEWAL_FRANCHISE = 'CLOSE_MODAL_RENEWAL_FRANCHISE'

export const OPEN_MODAL_RECEPTIVE_PRODUCT = 'OPEN_MODAL_RECEPTIVE_PRODUCT'
export const CLOSE_MODAL_RECEPTIVE_PRODUCT = 'CLOSE_MODAL_RECEPTIVE_PRODUCT'

export const OPEN_MODAL_PLAN_RULES = 'OPEN_MODAL_PLAN_RULES'
export const CLOSE_MODAL_PLAN_RULES = 'CLOSE_MODAL_PLAN_RULES'

export const OPEN_MODAL_FAIL_PAYMENT = 'OPEN_MODAL_FAIL_PAYMENT';
export const CLOSE_MODAL_FAIL_PAYMENT = 'CLOSE_MODAL_FAIL_PAYMENT';

export const SET_OPERATOR_CONFIRMATION_CLICKED = 'SET_OPERATOR_CONFIRMATION_CLICKED';
// #endregion

export const OPEN_MODAL_NOT_COVID_COVERAGE = 'OPEN_MODAL_NOT_COVID_COVERAGE'
export const CLOSE_MODAL_NOT_COVID_COVERAGE = 'CLOSE_MODAL_NOT_COVID_COVERAGE'

export const SHOW_INVALID_CREDIT_CARD_ERROR = 'SHOW_INVALID_CREDIT_CARD_ERROR'
export const HIDE_INVALID_CREDIT_CARD_ERROR = 'HIDE_INVALID_CREDIT_CARD_ERROR'
// #endregion

export const SET_USER_DETAILS = 'SET_USER_DETAILS'

// change confirm terms in purchase
export const CHANGE_CONFIRM_TERMS = 'CHANGE_CONFIRM_TERMS'

// clean errors
export const CLEAN_ERRORS = 'CLEAN_ERRORS'

// version mobile
export const ACCESS_IS_MOBILE = 'ACCESS_IS_MOBILE'
export const NEXT_STAGE_PURCHASE_MOBILE = 'NEXT_STAGE_PURCHASE_MOBILE'
export const STAGE_PAYMENT_CREDIT_CARD = 'STAGE_PAYMENT_CREDIT_CARD'
export const STAGE_PAYMENT_CASH_TRANSFER = 'STAGE_PAYMENT_CASH_TRANSFER'
export const EDIT_PURCHASE = 'EDIT_PURCHASE'
export const SELECT_PAYMENT_ALTER_STATE = 'SELECT_PAYMENT_ALTER_STATE'
export const BACK_STAGE_PURCHASE = 'BACK_STAGE_PURCHASE'
export const BACK_STAGE_PAYMENT_METHOD = 'BACK_STAGE_PAYMENT_METHOD'
export const CLEAN_STATES_PURCHASE_MOBILE = 'CLEAN_STATES_PURCHASE_MOBILE'
export const VALIDATOR_HANDLER_BLUR = 'VALIDATOR_HANDLER_BLUR'

export const GET_INFOS_PROSPECT = 'GET_INFOS_PROSPECT'
export const SET_INFOS_PROSPECT_IN_PURCHASE = 'SET_INFOS_PROSPECT_IN_PURCHASE'
export const CLEAR_INFOS_PROSPECT = 'CLEAR_INFOS_PROSPECT'
export const GET_INFOS_INSUREDS = 'GET_INFOS_INSUREDS'


// Common types
export const OPEN_MODAL_QUOTATION_DATE_WARNING = 'OPEN_MODAL_QUOTATION_DATE_WARNING'
export const CLOSE_MODAL_QUOTATION_DATE_WARNING = 'CLOSE_MODAL_QUOTATION_DATE_WARNING'
export const OPEN_MODAL_QUOTATION_DATE_YEAR = 'OPEN_MODAL_QUOTATION_DATE_YEAR'
export const CLOSE_MODAL_QUOTATION_DATE_YEAR = 'CLOSE_MODAL_QUOTATION_DATE_YEAR'
export const OPEN_MODAL_WITHOUT_TRACKER = 'OPEN_MODAL_WITHOUT_TRACKER'
export const CLOSE_MODAL_WITHOUT_TRACKER = 'CLOSE_MODAL_WITHOUT_TRACKER'

// tracker modal
export const SET_TRACKER_INFOS_PROSPECT = 'SET_TRACKER_INFOS_PROSPECT'
export const TRACKER_MODAL_VALIDATOR_HANDLER_BLUR = 'TRACKER_MODAL_VALIDATOR_HANDLER_BLUR'
export const VALIDATE_TRACKER_MODAL_REDIRECT = 'VALIDATE_TRACKER_MODAL_REDIRECT'

export const SET_BENEFITS = 'SET_BENEFITS'


// Ecommerce settings
export const SEARCH_ECOMMERCE_SETTINGS = "SEARCH_ECOMMERCE_SETTINGS"
export const SEARCH_PROVIDER_SETTINGS = "SEARCH_PROVIDER_SETTINGS"


// DESTINATIONS
export const GLOBAL_DESTINATIONS = "GLOBAL_DESTINATIONS"
export const GLOBAL_PROVIDER_SETGINGS = "GLOBAL_PROVIDER_SETGINGS"

// Payment methods
export const PURCHASE_GET_PAYMENT_METHODS = "PURCHASE_GET_PAYMENT_METHODS"

export const STORE_HIGHLIGTH_PLANS = "STORE_HIGHLIGTH_PLANS"
export const TOGGLE_SPECIALIST_SUGGESTION = "TOGGLE_SPECIALIST_SUGGESTION"

export const OPEN_MODAL_UPSELL = "OPEN_MODAL_UPSELL"
export const CLOSE_MODAL_UPSELL = "CLOSE_MODAL_UPSELL"

export const SET_UPSELL_PLANS = "SET_UPSELL_PLANS"
export const SET_UPSELL_SOURCE_TAGS = "SET_UPSELL_SOURCE_TAGS"

export const SET_UPSELL_PURCHASE = "SET_UPSELL_PURCHASE"



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js